/**
 * Gift wrap is its own cart line, paired to the item it wraps by a shared
 * `_gift_wrap_key` property. The wrapped item also carries `Gift_Wrap: "Yes"`;
 * the wrap line carries the key alone. The contract is the legacy theme's, so
 * carts started there still pair up — the Liquid in snippet.cart-content and
 * section.header applies the same test.
 */
export const isGiftWrapLine = (item) =>
  Boolean(item.properties?._gift_wrap_key) && !item.properties?.Gift_Wrap;

export const isGiftWrapped = (item) => item.properties?.Gift_Wrap === "Yes";

/** The cart's item count, less the gift-wrap lines it never shows. */
export const visibleItemCount = (cart) =>
  cart.items.reduce(
    (count, item) => (isGiftWrapLine(item) ? count : count + item.quantity),
    0,
  );
